import client from './client'

/**
 * @param {{ name: string, phone: string, event_date: string, package?: string, message?: string }} payload
 */
export const submitContact = (payload) => client.post('/contact', payload)

// Alias matching the prompt-defined name
export const submitContactForm = submitContact
